export default "__VITE_ASSET__3efb7cfe__"